import { createReducer } from '@reduxjs/toolkit'

import { dspOrdersTableColumnsConfig } from 'configuration/tables/dspCampaignFactsTable'
import {
    ADVANCED_TEXT,
    BRANDS,
    DATES,
    DSP_ADVERTISERS,
    DSP_COUNTRIES,
    DSP_ORDERS,
    LABELS,
    METRIC_FILTERS,
} from 'const/filters'
import { FILTER_SETTINGS, FILTERS } from 'const/reducerKeys'
import { serializeColumns } from 'helpers/tables'
import { defaultTab, getDefaultTable } from 'reducers/ui/defaults'

const initialState = {
    ...defaultTab,
    [FILTERS]: {
        [ADVANCED_TEXT]: [],
        [BRANDS]: [],
        [DSP_ADVERTISERS]: [],
        [DSP_ORDERS]: [],
        [LABELS]: [],
        [DSP_COUNTRIES]: [],
        [METRIC_FILTERS]: [],
    },
    [FILTER_SETTINGS]: {
        anchored: [DATES],
        order: [
            ADVANCED_TEXT,
            BRANDS,
            DSP_ADVERTISERS,
            DSP_ORDERS,
            LABELS,
            DSP_COUNTRIES,
            METRIC_FILTERS,
        ],
        displayState: {
            [ADVANCED_TEXT]: true,
            [BRANDS]: true,
            [DSP_ADVERTISERS]: true,
            [DSP_ORDERS]: true,
            [LABELS]: true,
            [DSP_COUNTRIES]: true,
            [METRIC_FILTERS]: true,
        },
    },
    table: getDefaultTable(serializeColumns(dspOrdersTableColumnsConfig), {
        sorter: {
            field: 'total_cost__sum',
            order: 'descend',
        },
    }),
}

export default createReducer(initialState, () => {})
